import { Typography, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import { industryList } from '../../datamodels/IndustryRecords.ts'
import '../../styles/mobidawg-style.scss';

// TODO Need to add this: "Backend-connected, mobile applications, proof-of-concept and mobile strategy across industry domains."

function HomeIndustries() {
    return (
        <Box sx={{ width: '100%', mt: 2 }}>
            <Typography sx={{ 
                            height: '3rem', 
                            fontSize: '1.2rem', fontWeight: 'bold', 
                            m: '0rem', p: '0rem',
                            boxSizing: 'border-box',
                            display: 'flex',                // Enable flexbox layout
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundImage: 'conic-gradient(from 90deg,rgb(205, 236, 200) 10%,rgb(177, 205, 172) 80%,rgb(205, 236, 200) 29% )'}}>
            
                INDUSTRY EXPERIENCE
                
            </Typography>
            <Box sx={{ width: '100%' }}>
                    <Card sx={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}> 
                        <CardActionArea sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <CardContent sx={{ padding: 0, flex: 1, width: '100%' }}>
                        {industryList.filter(industry => industry.isVisible ?? true).sort((a, b) => a.title.localeCompare(b.title)).map((industry) => (

                            <Typography
                                key={industry.id}
                                component= "div"
                                variant="body1"
                                sx={{  
                                    // color: 'black',                 // Set text color
                                    borderRadius: '4px',            // Add rounded corners (optional)
                                    m: '0rem', pt: '0.75rem',
                                    width: '100%',
                                    fontSize: '1.2rem',
                                    boxSizing: 'border-box',
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'left',
                                    wordWrap: 'break-word',
                                    overflowWrap: 'break-word'
                                }}>
                                {industry.icon && ( // Correct conditional rendering
                                    <industry.icon sx={{ width: '10%', width: 28, height: 28, ml: '1.5rem', mr: '1rem' }} />
                                )}
                                <Box>
                                    <Typography variant="body1" component="span" sx={{ fontSize: '1rem', fontWeight: 'bold', display: 'flex', overflowWrap: 'anywhere' }} >
                                        {industry.title}
                                    </Typography>
                                    <Typography variant="body1" component="span" sx={{ width: '90%', fontSize: '0.9rem', display: 'flex', overflowWrap: 'break-word', ml: '0.2rem' }} >
                                        {industry.briefDescription}
                                    </Typography>
                                </Box>
                            </Typography>
                        ))}
                        </CardContent>
                        </CardActionArea>
                    </Card>
            </Box>
        </Box>
    );
}

export default HomeIndustries;

